module.exports = __webpack_public_path__ + "img/icon-3-bg.f2fba907.png";